/**
 * Vue site data
 */
import {
    isProdSite,
    isTestEnv
} from '@/helpers/deployment';

export const plugin = {
    name: 'site',

    pluginProperties: {
        site: 'taide.art',
        isProdSite,
        isTestEnv
    },

    install (Vue) {
        Vue.prototype.$site = this.pluginProperties.site;

        // deployment variables
        Vue.prototype.isProdSite = isProdSite;
        Vue.prototype.isTestEnv = isTestEnv;

        // init global TAIDEART object, this may be injected into on server side
        window.TAIDEART = window.TAIDEART || {};
    }
};

export default plugin;
